<div class="common-error" [ngClass]="{'common-error--tmh-corporate-admin': isTmhCorporateAdmin}">
  <img tabindex="0" src="{{ state?.image?.iconPath }}" alt={{state?.image?.altText}}>
  <p class="common-error--{{ message.cssClass? message.cssClass : 'error-message-section' }}" tabindex="0" *ngFor="let message of state.messages">
    {{ message.message }}
  </p>
  
</div>
